import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { testimonials } from '../data/testimonials';
import { site } from '../data/site';
export function TestimonialsSection() {
  if (!site.showTestimonials) return null;
  return <section className="bg-brand-alt px-4 py-16 md:py-24" data-id="element-167" data-mp="1mxxxd8vmeqlo">
      <Reveal className="mx-auto max-w-[1120px]" data-id="element-168" data-mp="1r0kn948qe1g8">
        <div className="mb-10 text-center md:mb-12" data-id="element-169" data-mp="1d1unthyfvpop">
          <p className="mb-3 text-[11px] font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-170" data-mp="1d135h8turogd">TEACHER EXPERIENCES</p>
          <h2 className="text-3xl font-black text-brand-blue md:text-[2.5rem]" data-id="element-171" data-mp="1i28xt5jlp9pd">What PE Teachers Are Saying</h2>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-172" data-mp="143j13r0p1c1j">
          {testimonials.map(({
          id,
          quote,
          name,
          role
        }) => <article key={id} className="flex min-h-[200px] flex-col rounded-2xl border border-dashed border-brand-blue/20 bg-brand-main p-7" data-id="element-173" data-mp="2yenwk81mmi5s">
              <QuoteIcon className="h-5 w-5 text-brand-orange/60" aria-hidden="true" data-id="element-174" data-mp="2v1b1t0mbi2q2" />
              <p className="mt-4 flex-1 font-serif text-lg italic leading-relaxed text-brand-text/70" data-id="element-175" data-mp="2q2hlz1jk5zmq">{quote}</p>
              <div className="mt-6" data-id="element-176" data-mp="34r4antv2s3qm">
                <p className="text-sm font-bold text-brand-blue/70" data-id="element-177" data-mp="34q2p2vgfnyun">{name}</p>
                <p className="text-xs text-brand-gray/80" data-id="element-178" data-mp="2zs16ebmx61jp">{role}</p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}